/**
 * Section - card design v3 with bigger radius + softer shadow.
 */
import React from "react";
import { tokensV2 as T } from "./tokens.v2";

export function Section({ title, accent = T.brand.base, summary, count, children }) {
  return (
    <section style={{
      backgroundColor: T.surface.card,
      border: "none",
      borderRadius: 16,
      padding: 16,
      marginBottom: 10,
      fontFamily: T.font.sans,
      boxShadow: "0 1px 2px rgba(31,42,63,0.04)",
      position: "relative",
      overflow: "hidden",
    }}>
      <div style={{
        position: "absolute", left: 0, top: 16, bottom: 16, width: 3,
        backgroundColor: accent, borderRadius: 2,
      }} />
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        marginBottom: 12, paddingLeft: 12, gap: 10, flexWrap: "wrap",
      }}>
        <div>
          <div style={{ fontSize: 17, fontWeight: 700, color: T.text.primary, letterSpacing: "-0.01em" }}>{title}</div>
          {summary && (
            <div style={{ fontSize: 12, color: T.text.muted, marginTop: 4, fontVariantNumeric: "tabular-nums" }}>{summary}</div>
          )}
        </div>
        {count != null && (
          <span style={{
            fontSize: 11, fontWeight: 600, color: T.text.muted,
            padding: "5px 12px",
            background: T.surface.canvas,
            border: "1px solid " + T.border.subtle,
            borderRadius: 999, whiteSpace: "nowrap", flexShrink: 0,
          }}>{count} metrics</span>
        )}
      </div>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(min(240px, 100%), 1fr))",
        gap: 14,
        paddingLeft: 12,
      }}>
        {children}
      </div>
    </section>
  );
}
